// extracted by mini-css-extract-plugin
module.exports = {"root":"_edbc6d","amountWrapper":"_2ad9d2","amount":"_3be4a6","tag":"_cb4929","free":"_25fac8"};